import { groupTypeValues, OPTION_ALL } from '../constants';
import { BOOK_TYPES } from '../../shared/constants';

export default {
  reportData: { rows: [], name: '', orientation: '', columnCount: 0, rawSource: [] },
  reportDataByBookType: {},
  drillDetail: [],
  selectedEntry: {},
  isDrillDetailLoading: false,
  viewType: 'rows',
  reportBookType: BOOK_TYPES.US_FED,
  selectedReportBookTypes: Object.values(BOOK_TYPES),
  groupType: groupTypeValues.BUSINESS_UNITS,
  taxExpenseLoading: false,
  isExportingReportForAllPills: false,
  companyCodesOptions: [],
  companyCodeToFilter: OPTION_ALL.value,
  customGroupOptions: [],
  customGroup: null,
  isFetchingCountryTaxTypes: false,
  countryTaxTypesOptions: [],
  countryTaxType: OPTION_ALL.value,
  detailAggregationType: 'ACCOUNT',
};
